import clsxImported, { ClassValue } from 'clsx';

export const clsx = (...args: ClassValue[]): string => {
  return clsxImported(args);
};
